/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function MediaAcceptProfilesTextValidatorEditViewController(this: JS5Object, MediaAcceptProfileService: JS5Object,
                                                            uiGridConstants: JS5Object, $location: JS5Object,
                                                            NavbarUtilService: JS5Object, ModalService: JS5Object,
                                                            $routeParams: JS5Object, $route: JS5Object, $timeout: JS5Function) {

    this.eia608 = false;
    this.eia708 = false;

    const setEiaFromFormat = (format: string) => {
        this.eia608 = false;
        this.eia708 = false;
        if (_.includes(format, 'EIA-608')) {
            this.eia608 = true;
        }
        if (_.includes(format, 'EIA-708')) {
            this.eia708 = true;
        }
    };
    const getFormatStringFromEia = (eia608: boolean, eia708: boolean) => {
        let format = '';

        if (eia608 && !eia708) {
            format = 'EIA-608';
        } else if (!eia608 && eia708) {
            format = 'EIA-708';
        } else if (eia608 && eia708) {
            format = 'EIA-608,EIA-708';
        }
        return format;
    };
    const setValidator = (validators: Array<JS5Object>) => {
        this.validators = validators;
        if (_.some(validators, {validatorType: 'TEXT'})) {
            let validator = _.first(_.remove(validators, <JS5Object>{validatorType: 'TEXT'}));
            this.editData = _.cloneDeep(validator);
        } else {
            this.editData = {format: ''};
        }
        MediaAcceptProfileService.originalTextValidatorEditData = _.cloneDeep(this.editData);

    };

    const getData = () => {
        this.loadingIndicator.show = true;
        MediaAcceptProfileService.getValidators($routeParams.id, false).then((validators: Array<JS5Object>) => {
            setValidator(validators);
            setEiaFromFormat(this.editData.format);
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };


    const saveHandler = () => {
        this.loadingIndicator.show = true;
        this.editData.format = getFormatStringFromEia(this.eia608, this.eia708);
        this.editData.validatorType = "TEXT";
        this.editData.trackNumber = "0";
        this.loadingIndicator.show = true;
        let validatorsToSave = _.concat([this.editData], this.validators);
        MediaAcceptProfileService.updateValidators($routeParams.id, validatorsToSave).then((validators: Array<JS5Object>) => {
            setValidator(validators);
            setEiaFromFormat(this.editData.format);
        }).finally(() => {
            this.loadingIndicator.show = false;
            this.setFormPristine();
        });
    };


    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => !_.get(this.editorForm, '$pristine'),
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: () => !_.get(this.editorForm, '$pristine'),
            onClick: () => {
                this.editorForm.$setPristine();
                this.editData = _.cloneDeep(MediaAcceptProfileService.originalTextValidatorEditData);
                setEiaFromFormat(this.editData.format);
                this.setFormPristine();

            }
        },
        {
            label: 'Close',
            enabled: () => true,
            onClick: () => $location.url(`/system/templates/search`).search({
                tab: 'Media',
                subTab: 'MediaAcceptProfiles'
            })

        }
    ];

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        getData();
    };

    this.$postLink = () => {
        $timeout(() => {
            MediaAcceptProfileService.editorForm = this.editorForm;
        });
    };

    this.$onDestroy = () => {
        MediaAcceptProfileService.editorForm = null;
    };
}


angular.module('prism-ui.mediaAcceptProfiles').component('mediaAcceptProfilesTextValidatorEditView', {
    templateUrl: 'system/templates/mediaAcceptProfiles/components/validators/text/editor/media-accept-profiles-text-validator-edit-view-template.html',
    controller: MediaAcceptProfilesTextValidatorEditViewController,
    bindings: {
        setFormPristine: '&'
    }
});
